import React, { useEffect, useState } from "react";
import Section from "../../../components/Section";
import { pageTitle } from "../../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../../components/SecondaryButton";

import InputField from "../../../components/InputField";
import axiosInstance from "../../../utils/axiosInstance";
import { addEditAwards, addEditExperience, fetchDoctorProfile, fetchDoctorServicesList, registerUser, updateUserDetais } from "../../../constants/ApiConstants";
import { useNavigate } from "react-router-dom";
import CommonMobileHeader from "../../../components/Header/CommonMobileHeader";
import FullPageLoader from "../../../components/FullPageLoader";
import ListEmptyText from "../../../components/ListEmptyText";
import MyModal from "../../../components/MyModal";

export default function ManageAwards() {
  pageTitle("Manage Awards");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData?.id);
  const [doctorDetail, setDoctorDetail] = useState(null);

  const [editAwardsData, setEditAwardsData] = useState();
  const [deleteAwardsId, setDeleteAwardsId] = useState("");
  const [editAwardsModalOpen, setEditAwardsModalOpen] = useState(false);
  const [deleteAwardsModalOpen, setDeleteAwardsModalOpen] = useState(false);
  const [addAwardsModalOpen, setAddAwardsModalOpen] = useState(false);
  const [addAwardsData, setAddAwardsData] = useState(null);

  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEditPress = (awardsData) => {
    setEditAwardsData(awardsData);
    setEditAwardsModalOpen(true);
  };

  const handleDeletePress = (awardsData) => {
    setDeleteAwardsId(awardsData.id);
    setDeleteAwardsModalOpen(true);
  };

  const handleOpenAddServiceModal = () => {
    setAddAwardsModalOpen(true);
    setAddAwardsData({ title: "" });
  };

  const closeAddModal = () => setAddAwardsModalOpen(false);
  const closeEditModal = () => setEditAwardsModalOpen(false);
  const closeDeleteModal = () => setDeleteAwardsModalOpen(false);

  const onAddSubmit = () => {
    if (!editAwardsData?.title === "") {
      toast.error("Please provide Award title");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addEditAwards, {
        doctor_id: doctorId,
        title: addAwardsData?.title,
        type: 1,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Award added successfully.");
          setAddAwardsData("");
          setAddAwardsModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onEditSubmit = () => {
    if (!editAwardsData?.title === "") {
      toast.error("Please provide Award title");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addEditAwards, {
        doctor_id: doctorId,
        title: editAwardsData?.title,
        award_id: editAwardsData?.id,
        type: 2,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Award updated successfully.");
          setEditAwardsData("");
          setEditAwardsModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onDeleteClick = () => {
    setSubmitting(true);
    axiosInstance
      .post(addEditAwards, {
        doctor_id: doctorId,
        award_id: deleteAwardsId,
        type: 3,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Award deleted successfully.");
          setDeleteAwardsId("");
          setDeleteAwardsModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Wrapper>
      {loading ? (
        <FullPageLoader />
      ) : (
        <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="content-wrapper d-flex flex-column px-3 gap-1 justify-content-center mx-auto">
            <CommonMobileHeader
              canBack
              title="Awards"
              trailing={
                <button type="button" className="bg-success-surface px-3 rounded" onClick={handleOpenAddServiceModal}>
                  Add Award
                </button>
              }
            />
            <div className="row">
              <div className="col-md-6">
                <div className="py-3 bg-white">
                  <strong className="text-dark">MANAGE AWARDS</strong>
                  <p className="text-grey2 fs-normal">Example: Dr. B.C. Roy Award, ICMR Lala Ram Chand Kandhari Award, Etc.</p>
                </div>
              </div>
              <div className="col-md-6">
                {!loading && doctorDetail && doctorDetail?.awards.length === 0 && <ListEmptyText text={"No Award added yet."} />}
                {!loading && doctorDetail && doctorDetail?.awards.length > 0 && (
                  <div className="w-full">
                    {doctorDetail?.awards.map((award) => (
                      <div key={award.id} className="d-flex justify-content-between bg-grey2 mb-2 rounded">
                        <strong className="fs-normal text-grey2 fw-normal px-3 py-2  ">{award.title}</strong>
                        <div className="d-flex gap-2">
                          <button type="button" className="bg-warning-surface px-3 rounded" onClick={() => handleEditPress(award)}>
                            Edit
                          </button>
                          <button type="button" className="bg-danger-surface px-3 rounded" onClick={() => handleDeletePress(award)}>
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Section>
      )}
      {/* Edit Expertise Modal */}
      <MyModal isOpen={editAwardsModalOpen} modalTitle={"Edit Award"} onClose={closeEditModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField name={"awardName"} value={editAwardsData?.title} onChange={(e) => setEditAwardsData({ ...editAwardsData, title: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onEditSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Add Expertise Modal */}
      <MyModal isOpen={addAwardsModalOpen} modalTitle={"Add Award"} onClose={closeAddModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField name={"awardName"} value={addAwardsData?.title} onChange={(e) => setAddAwardsData({ ...addAwardsData, title: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onAddSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Delete Modal */}
      <MyModal isOpen={deleteAwardsModalOpen} modalTitle={"Delete Award"} onClose={closeDeleteModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <SecondaryButton title="Delete" onClick={onDeleteClick} loading={submitting} />
        </div>
      </MyModal>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
